import { mainBackendApi } from '@/services'
import type { UserBalance, BalanceLedgerEntry } from '@/models/Balance'

export const BalanceService = mainBackendApi.injectEndpoints({
	endpoints: build => ({
		getBalance: build.query<UserBalance, void>({
			query: () => ({
				url: '/client/balance/',
				method: 'GET',
			}),
			transformResponse: (res: UserBalance) => ({
				...res,
				available: Number(res.available),
			}),
			providesTags: ['Balance'],
		}),
		getBalanceHistory: build.query<BalanceLedgerEntry[], { skip?: number; limit?: number } | void>({
			query: (params) => ({
				url: '/client/balance/history',
				method: 'GET',
				params: params ?? undefined,
			}),
			transformResponse: (res: BalanceLedgerEntry[]) =>
				res.map(e => ({
					...e,
					amount: Number(e.amount),
					balanceBefore: Number(e.balanceBefore),
					balanceAfter: Number(e.balanceAfter),
				})),
			providesTags: ['Balance'],
		}),
	}),
})
